import React from 'react';
import { PropTypes } from 'prop-types';
import Checkbox from './Checkbox';
import ParagraphLineSM from '../TextSupportingComponents/ParagraphLineSM';

const ExpandLessWhite = props => <span {...props} className="font-icon icon-arrow-up font-black text-white text-xxs" />;

const ExpandMoreWhite = props => <span {...props} className="font-icon icon-arrow-down font-black text-white text-xxs" />;

const ExpandLessBlack = props => <span {...props} className="font-icon icon-arrow-up font-black text-black text-xs" />;

const ExpandMoreBlack = props => <span {...props} className="font-icon icon-arrow-down font-black text-black text-xs" />;

class DropDownMenu extends React.Component {
  state = {
    anchorEl: null,
    checkedItems: [],
    selected: '',
  };

  componentDidMount() {
    const { arr, filterType } = this.props;
    const selected = arr[0] !== '0' ? arr[0] : '';
    this.setState({
      checkedItems: arr,
      selected,
      filterType,
    });
    document.addEventListener('mousedown', this.handleDocumentMouseDown);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentMouseDown);
  }

  componentDidUpdate(prevProps, prevState) {
    const { arr, action } = this.props;
    if (prevProps.arr !== arr) {
      this.setState({
        checkedItems: arr,
      });
      if (action === 'unique') {
        const selected = arr[0] !== '0' ? arr[0] : '';
        this.setState({
          selected,
        });
      }
    }
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  // MUI's Menu rendered an invisible backdrop that swallowed the next click and closed
  // itself. A plain panel has no such thing, so the outside click is wired by hand.
  // mousedown rather than click, so it fires before a MenuItem's own onClick.
  handleDocumentMouseDown = (event) => {
    const { anchorEl } = this.state;
    if (!anchorEl) return;
    if (this.rootRef && this.rootRef.contains(event.target)) return;
    this.handleClose();
  };

  setRootRef = (node) => {
    this.rootRef = node;
  };

  handleChange = value => () => {
    const { checkedItems } = this.state;
    const items = [...checkedItems];
    const index = items.indexOf(value.toLowerCase());
    if (index === -1) {
      items.push(value.toLowerCase());
      const { onHandleChange } = this.props;
      this.setState({ checkedItems: items }, () => onHandleChange(items));
    } else {
      const { onHandleChange } = this.props;
      items.splice(index, 1);
      this.setState({ checkedItems: items }, () => onHandleChange(items));
    }
  };

  handleChangeUnique = (value) => {
    const { onHandleChange } = this.props;
    this.setState({ selected: value });
    onHandleChange(value);
  }

  render() {
    let ExpandMore = ExpandMoreWhite;
    let ExpandLess = ExpandLessWhite;

    const {
      menuTitle, menuItems, white, text, action, arr, style,
    } = this.props;

    const { checkedItems, anchorEl, selected } = this.state;

    if (white) {
      ExpandMore = ExpandMoreBlack;
      ExpandLess = ExpandLessBlack;
    }
    return (
      <div className="w-full mb-4 ps-dropdown" ref={this.setRootRef}>
        <ParagraphLineSM classes={`text-white ${style || 'mb-2'}`} text={text} />

        <button
          type="button"
          className={`ps-dropdown__button ps-dropdown__button--${white ? 'white' : 'black'}`}
          aria-owns={anchorEl ? menuTitle : undefined}
          aria-haspopup="true"
          aria-expanded={Boolean(anchorEl)}
          onClick={this.handleClick}
        >
          <div className="flex justify-between w-full items-center px-2">
            <span className="font-americaMonoRegular text-xs uppercase">{(checkedItems && checkedItems.join(', ')) || (arr && arr.join(', '))}</span>
            {anchorEl ? <ExpandLess color="black" /> : <ExpandMore />}
          </div>
        </button>
        <div className="ps-dropdown__menu" id="simple-menu" hidden={!anchorEl}>
          {action === 'create'
            && menuItems.map((item, index) => (
              <button type="button" className="ps-dropdown__item" key={item.text || item.value + index} onClick={this.handleChange(item.value)}>
                <Checkbox checked={checkedItems.includes(item.value.toLowerCase())} disabled={checkedItems.includes(item.value)} value="checkedA" />
                <span>{item.text || item.value}</span>
              </button>
            ))}
          {action === 'modify'
            && menuItems.map((item, index) => (
              <button type="button" className="ps-dropdown__item" key={item.text || item.value + index} onClick={this.handleChange(item.value)}>
                <Checkbox checked={checkedItems.includes(item.value.toLowerCase())} disabled={checkedItems.includes(item.value.toLowerCase())} value="checkedA" />
                <span>{item.text || item.value}</span>
              </button>
            ))}
          {(action === 'display' || action === 'delete')
            && menuItems.map((item, index) => (
              <div className="ps-dropdown__item ps-dropdown__item--static" key={item.text || item.value + index}>
                <Checkbox checked={arr.includes(item.value.toLowerCase())} disabled={arr.includes(item.value.toLowerCase())} value="checkedA" />
                <span>{item.text || item.value}</span>
              </div>
            ))}
          {action === 'unique'
            && menuItems.map((item, index) => (
              <button type="button" className="ps-dropdown__item" key={item.text || item.value + index} onClick={() => this.handleChangeUnique(item.value)}>
                <Checkbox checked={selected === item.value} value="checkedA" />
                <span>{item.text || item.value}</span>
              </button>
            ))}
        </div>
      </div>
    );
  }
}

DropDownMenu.propTypes = {
  menuTitle: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.shape().isRequired).isRequired,
  onHandleChange: PropTypes.func.isRequired,
  white: PropTypes.bool,
  arr: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.string,
};

DropDownMenu.defaultProps = {
  white: true,
  arr: [],
  style: '',
};

export default DropDownMenu;
